export const subjectVerbAgreementQuestions = [
  {
    id: 1,
    koreanQuestion: "50달러가 충분하다 사기에 그 책을",
    question: "Fifty dollars ______ enough to buy the book.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "금액은 하나의 총액으로 보아 단수 취급합니다. 50달러들이라고 안하니까 단수다 라고 생각하면 쉽습니다.",
    translation: "50달러가 그 책을 사기에 충분하다.",
    type: "subject-verb agreement",
  },
  {
    id: 2,
    koreanQuestion: "위원회가 도달했다 만장일치 결정에 ",
    question: "The committee ______ reached a unanimous decision.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation:
      "위원회(committee)는 하나의 단체로서 단수 취급, 위원회들 이라고 안하니 단수구나, 생각하면 쉽습니다.",
    translation: "위원회가 만장일치 결정에 도달했다.",
    type: "subject-verb agreement",
  },
  {
    id: 3,
    koreanQuestion: "2킬로미터가 너무 멀다 걷기에는",
    question: "Two kilometers ______ too far to walk.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "거리는 하나의 단위로 보아 단수 취급합니다. 우리가 2킬로미터들 이라고 안하는 것처럼 단수라고 생각하면 쉽습니다.",
    translation: "2킬로미터는 걷기에는 너무 멀다.",
    type: "subject-verb agreement",
  },
  {
    id: 4,
    koreanQuestion: "각각 학생들 받았다 장학금을 ",
    question: "Each of the students ______ received a scholarship.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation: "'Each of'는 항상 단수 취급",
    translation: "학생들 각각이 장학금을 받았다.",
    type: "subject-verb agreement",
  },
  {
    id: 5,
    koreanQuestion: "또다른 이유가 지연된 확인되었다",
    question: "Another reason for the delay ______ been identified.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation: "'Another + 단수명사'는 항상 단수 취급합니다.",
    translation: "지연의 또 다른 이유가 확인되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 6,
    koreanQuestion: "한 명이 후보자들 중 선발되었다 그 직책에",
    question: "One of the candidates ______ selected for the position.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "A",
    explanation:
      "'One of + 복수명사'는 항상 단수 취급합니다. 따라서 단수 동사 was를 사용합니다.",
    translation: "후보자들 중 한 명이 그 직책에 선발되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 7,
    koreanQuestion: "하나가 열쇄들 중 없어졌다 책상에서 ",
    question: "One of the keys ______ missing from the desk.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'One of + 복수명사'는 항상 단수 취급합니다. -들중 하나로 해석하면 헷갈리지 않습니다.",
    translation: "열쇠들 중 하나가 책상에서 없어졌다.",
    type: "subject-verb agreement",
  },
  {
    id: 8,
    koreanQuestion: "아무도 사무실의 몰랐다 일정 변경을 오늘 아침까지 ",
    question:
      "No one in the office ______ aware of the schedule change until this morning.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "A",
    explanation:
      "'No one'은 단수 취급, 없는건 하나니까 단수다. 라고 생각하면 쉽습니다.",
    translation: "사무실의 누구도 오늘 아침까지 일정 변경을 알지 못했다.",
    type: "subject-verb agreement",
  },
  {
    id: 9,
    koreanQuestion:
      "많은 직원들이 표명했다 관심을 회사의 새로운 전문성 개발 프로그램에 ",
    question:
      "Many employees ______ expressed interest in the company's new professional development program.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'Many employees'는 복수 주어이므로 복수 동사 have를 사용합니다.",
    translation:
      "많은 직원들이 회사의 새로운 전문성 개발 프로그램에 관심을 표명했다.",
    type: "subject-verb agreement",
  },
  {
    id: 10,
    koreanQuestion:
      "모든 사람은 그... 참석하는 회의에 요구된다 등록하도록 미리 사전에 ",
    question:
      "Everyone attending the conference ______ required to register in advance.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Everyone'은 단수 취급, '모든 사람'이란 자체를 하나로 보면 쉽습니다.",
    translation: "회의에 참석하는 모든 사람이 사전 등록을 해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 11,
    koreanQuestion:
      "누구든지 그... 관심있는 이 직책에 반드시 제출해야 한다 지원서를 금요일까지   ",
    question:
      "Anyone who ______ interested in the position must submit an application by Friday.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Anyone'은 단수 취급하며, 관계대명사절의 주어로도 단수 동사를 사용합니다. 따라서 is가 적절합니다.",
    translation:
      "이 직책에 관심이 있는 사람은 누구나 금요일까지 지원서를 제출해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 12,
    koreanQuestion: " 수는 지원자의 관리자 직책에 크게 증가했다 비교해서 작년 ",
    question:
      "The number of applicants for the managerial position ______ significantly increased compared to last year.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation:
      "'The number of'는 단수 취급하며, 뒤에 오는 복수 명사에 영향을 받지 않습니다. 따라서 단수 동사 has를 사용합니다. '수'라는 개념은 단수이므로 단수 동사를 사용합니다.",
    translation:
      "관리자 직책에 지원한 지원자의 수가 작년에 비해 크게 증가했다.",
    type: "subject-verb agreement",
  },
  {
    id: 13,
    koreanQuestion: "수가 직원들 그..재택근무하는 증가했다 최근 몇 년간 ",
    question:
      "The number of employees working remotely ______ risen in recent years.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation:
      "'The number of'는 단수 주어이므로 단수 동사를 사용합니다. 직원의 수들 이라고 안하는 것처럼 단수 취급합니다.",
    translation: "원격 근무하는 직원의 수가 최근 몇 년간 증가했다.",
    type: "subject-verb agreement",
  },
  {
    id: 14,
    koreanQuestion:
      "수가 고객 불만들 그... 지연된 배송에 관한 감소했다 새로운 물류 관리 시스템 도입 후 ",
    question:
      "The number of customer complaints regarding delayed shipments ______ decreased after the new logistics system.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation:
      "'The number of' 다음에 복수 명사가 오더라도 전체 주어는 단수 취급합니다. 고객들 불만이 아닌 불만의 '수'가 감소했다는 것",
    translation:
      "배송 지연에 관한 고객 불만의 수가 새로운 물류 시스템 도입 후 감소했다.",
    type: "subject-verb agreement",
  },
  {
    id: 15,
    koreanQuestion:
      "많은 최근 연구들이 보여주었다 중요성을 유지하는것 건강한 일과 삶의 밸런스를  ",
    question:
      "A number of recent studies ______ shown the importance of maintaining a healthy work-life balance.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 have를 사용합니다.",
    translation:
      "최근 여러 연구들이 일과 삶의 균형 유지의 중요성을 보여주었다.",
    type: "subject-verb agreement",
  },
  {
    id: 16,
    koreanQuestion:
      "소수의 후보자들만이 충족할 수 있었다 엄격한 요구사항들을 고위 관리직을 위한",
    question:
      "Few candidates _____ able to meet the strict requirements for the senior management position.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "B",
    explanation:
      "'Few + 복수명사'는 복수 취급하므로 복수 동사 were를 사용합니다.",
    translation:
      "소수의 후보자들만이 고위 관리직의 엄격한 요구사항을 충족할 수 있었다.",
    type: "subject-verb agreement",
  },
  {
    id: 17,
    koreanQuestion:
      "몇 가지 조정이 만들어져야 한다 최종보고서가 제출되기 전에 이사회에  ",
    question:
      "A few adjustments ______ to be made before the final report is submitted to the board.",
    choices: {
      A: "need",
      B: "needs",
    },
    correctAnswer: "A",
    explanation:
      "'A few + 복수명사'는 복수 취급하므로 복수 동사 need를 사용합니다.",
    translation:
      "최종 보고서를 이사회에 제출하기 전에 몇 가지 조정이 필요하다.",
    type: "subject-verb agreement",
  },
  {
    id: 18,
    koreanQuestion:
      "옵션 둘다 실행 가능하다, 하지만 경영진은 선택할 것이다 하나를 그.... 가장 부합하는 회사의 목표와 ",
    question:
      "Both options ______ viable, but the management team will select the one that aligns best with the company's goals.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "B",
    explanation: "'Both'는 항상 복수 취급하므로 복수 동사 are를 사용합니다.",
    translation:
      "두 가지 선택안 모두 실행 가능하지만, 경영진은 회사의 목표에 가장 잘 부합하는 것을 선택할 것이다.",
    type: "subject-verb agreement",
  },
  {
    id: 19,
    koreanQuestion:
      "여러 요인들이 기여했다 지연에 제품 출시, 포함하며 공급망 중단과 비용 증가를 ",
    question:
      "Several factors ______ to the delay in the product launch, including supply chain disruptions and increased costs.",
    choices: {
      A: "contributed",
      B: "contributes",
    },
    correctAnswer: "A",
    explanation:
      "'Several factors'는 복수 주어이므로 복수 동사 contributed를 사용합니다.",
    translation:
      "공급망 중단과 비용 증가를 포함한 여러 요인들이 제품 출시 지연에 기여했다.",
    type: "subject-verb agreement",
  },
  {
    id: 20,
    koreanQuestion:
      "수많은 고객들이 제공했다 긍정적인 피드백을 회사의 개선된 고객 서비스 정책에 대해  ",
    question:
      "Numerous customers ______ provided positive feedback on the company's improved customer service policies.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'Numerous customers'는 복수 주어이므로 복수 동사 have를 사용합니다.",
    translation:
      "수많은 고객들이 회사의 개선된 고객 서비스 정책에 대해 긍정적인 피드백을 제공했다.",
    type: "subject-verb agreement",
  },
  {
    id: 21,
    koreanQuestion: "많은 직원들이 참석했다 워크샵에 리더십 스킬에 관한 ",
    question:
      "A number of employees ______ attended the workshop on leadership skills.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 have를 사용합니다.",
    translation: "다수의 직원들이 리더십 기술 워크샵에 참석했다.",
    type: "subject-verb agreement",
  },
  {
    id: 22,
    koreanQuestion:
      "많은 새로운 정책들이 시행되었다 개선하기 위해 업무 효율성을 ",
    question:
      "A number of new policies ______ implemented to improve workplace efficiency.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 were를 사용합니다.",
    translation:
      "다수의 새로운 정책들이 업무 효율성을 개선하기 위해 시행되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 23,
    koreanQuestion: "많은 학생들이  지원하는 중이다 인턴십 프로그램에 올해",
    question:
      "A number of students ______ applying for the internship program this year.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 are를 사용합니다.",
    translation: "다수의 학생들이 올해 인턴십 프로그램에 지원하고 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 24,
    koreanQuestion: "다수의 기업들이 관심을 표명했다 파트너십에 우리 조직과의 ",
    question:
      "A number of companies ______ expressed interest in partnering with our organization.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 have를 사용합니다.",
    translation: "다수의 기업들이 우리 조직과의 파트너십에 관심을 표명했다.",
    type: "subject-verb agreement",
  },
  {
    id: 25,
    koreanQuestion: "다수의 요인들이 기여했다 최근의 감소에 매출에 있어서 ",
    question:
      "A number of factors ______ contributed to the recent decline in sales.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 have를 사용합니다.",
    translation: "다수의 요인들이 최근의 매출 감소에 기여했다.",
    type: "subject-verb agreement",
  },
  {
    id: 26,
    koreanQuestion: "다수의 불만사항이 접수되었다 새 제품의 기능성에 관해 ",
    question:
      "A number of complaints ______ received regarding the new product's functionality.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 were를 사용합니다.",
    translation: "다수의 불만사항이 새 제품의 기능성에 관해 접수되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 27,
    koreanQuestion:
      "다수의 연구원들이 수행하고 있다 연구를 영향에 대해 원격 근무  ",
    question:
      "A number of researchers ______ conducting studies on the impact of remote work.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "B",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 are를 사용합니다.",
    translation:
      "다수의 연구원들이 원격 근무의 영향에 대한 연구를 수행하고 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 28,
    koreanQuestion:
      "모든 사람들 회사안에 책임이 있다 유지할 안전하고 정돈된 업무 공간을  ",
    question:
      "Everyone in the company ______ responsible for maintaining a safe and organized workspace.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Everyone'은 단수 취급하며, 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation:
      "회사의 모든 사람이 안전하고 정돈된 업무 공간을 유지할 책임이 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 29,
    koreanQuestion: "누군가가 재무부로부터의 담당한다 급여 처리를 매월 말에",
    question:
      "Someone from the finance department ______ the payroll processing at the end of each month.",
    choices: {
      A: "handles",
      B: "handle",
    },
    correctAnswer: "A",
    explanation:
      "'Someone'은 단수 취급하며, 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation: "재무부의 누군가가 매월 말에 급여 처리를 담당한다.",
    type: "subject-verb agreement",
  },
  {
    id: 30,
    koreanQuestion:
      "아무도 사무실안에서 모른다 정확한 이유를 갑작스러운 일정 변경의 ",
    question:
      "Nobody in the office ______ the exact reason for the sudden schedule change.",
    choices: {
      A: "knows",
      B: "know",
    },
    correctAnswer: "A",
    explanation:
      "'Nobody'는 단수 취급하며, 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation: "사무실의 누구도 갑작스러운 일정 변경의 정확한 이유를 모른다.",
    type: "subject-verb agreement",
  },
  {
    id: 31,
    koreanQuestion: "모든 사람들 참석하는 교육세션에 받는다 자격증을 수료 시 ",
    question:
      "Everyone attending the training session ______ a certificate upon completion.",
    choices: {
      A: "receives",
      B: "receive",
    },
    correctAnswer: "A",
    explanation:
      "'Everyone'은 단수 취급하며, 현재분사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation: "교육 세션에 참석하는 모든 사람이 수료 시 자격증을 받는다.",
    type: "subject-verb agreement",
  },
  {
    id: 32,
    koreanQuestion:
      "누군가 강력한 리더십 스킬을 가진 이끈다 팀을 개발에서 새로운 사업 전략",
    question:
      "Someone with strong leadership skills ______ the team in developing a new business strategy.",
    choices: {
      A: "leads",
      B: "lead",
    },
    correctAnswer: "A",
    explanation:
      "'Someone'은 단수 취급하며, 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation:
      "강력한 리더십 기술을 가진 누군가가 새로운 사업 전략 개발에서 팀을 이끈다.",
    type: "subject-verb agreement",
  },
  {
    id: 33,
    koreanQuestion:
      "누구도 고객 서비스 부서안에서 이해하지 못한다 왜 시스템 장애가 발상했는지",
    question:
      "Nobody in the customer service department ______ why the system outage occurred.",
    choices: {
      A: "understands",
      B: "understand",
    },
    correctAnswer: "A",
    explanation:
      "'Nobody'는 단수 취급하며, 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation:
      "고객 서비스 부서의 누구도 시스템 장애가 발생한 이유를 이해하지 못한다.",
    type: "subject-verb agreement",
  },
  {
    id: 34,
    koreanQuestion:
      "모든 정보가 저장된다 보안 데이터베이스에 보호하기 위해 사용자 개인정보를  ",
    question:
      "All of the information ______ stored in a secure database to protect user privacy.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'All of the information'에서 'information'은 불가산 명사이므로 단수 취급하여 단수 동사 is를 사용합니다.",
    translation:
      "모든 정보가 사용자 개인정보 보호를 위해 보안 데이터베이스에 저장된다.",
    type: "subject-verb agreement",
  },
  {
    id: 35,
    koreanQuestion: "대부분이 작업이 이미 완료되었다 마감 전에 ",
    question:
      "Most of the work ______ already been completed ahead of the deadline.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "A",
    explanation:
      "'Most of the work'에서 'work'는 불가산 명사이므로 단수 취급하여 단수 동사 has를 사용합니다.",
    translation: "대부분의 작업이 이미 마감 전에 완료되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 36,
    koreanQuestion: "일부가 가구 교체되고 있다 마모로 인해 ",
    question:
      "Some of the furniture ______ being replaced due to wear and tear.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Some of the furniture'에서 'furniture'는 불가산 명사이므로 단수 취급하여 단수 동사 is를 사용합니다.",
    translation: "일부 가구가 마모로 인해 교체되고 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 37,
    koreanQuestion: "절반이 프로젝트 미완성이다 예상치 못한 지연으로 인해",
    question: "Half of the project ______ unfinished due to unexpected delays.",
    choices: {
      A: "remains",
      B: "remain",
    },
    correctAnswer: "A",
    explanation:
      "'Half of the project'에서 'project'는 단수 명사이므로 단수 동사 remains를 사용합니다.",
    translation: "프로젝트의 절반이 예상치 못한 지연으로 인해 미완성이다.",
    type: "subject-verb agreement",
  },
  {
    id: 38,
    koreanQuestion: "일부가 계약이 포함한다 기밀유지 조항을",
    question: "Part of the agreement ______ a confidentiality clause.",
    choices: {
      A: "includes",
      B: "include",
    },
    correctAnswer: "A",
    explanation:
      "'Part of the agreement'에서 'part'는 단수 명사이므로 단수 동사 includes를 사용합니다.",
    translation: "계약의 일부가 기밀유지 조항을 포함한다.",
    type: "subject-verb agreement",
  },
  {
    id: 39,
    koreanQuestion: "60%가 예산 배정되었다 마케팅 비용으로",
    question:
      "Sixty percent of the budget ______ allocated to marketing expenses.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "퍼센트 표현에서 'of' 뒤에 단수 명사가 올 경우 단수 동사를 사용합니다. 'budget'이 단수 명사이므로 is를 사용합니다.",
    translation: "예산의 60퍼센트가 마케팅 비용으로 배정되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 40,
    koreanQuestion:
      "품질과 고객 만족도가 한다 중요한 역할을 회사의 장기적 성공에서",
    question:
      "Quality and customer satisfaction ______ a crucial role in the company's long-term success.",
    choices: {
      A: "play",
      B: "plays",
    },
    correctAnswer: "A",
    explanation:
      "'and'로 연결된 두 개의 주어는 복수 취급하므로 복수 동사 play를 사용합니다.",
    translation:
      "품질과 고객 만족도가 회사의 장기적 성공에서 중요한 역할을 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 41,
    koreanQuestion: "생산부서와 물류팀이 협력했다 개선하기 위해 배송 효율성을 ",
    question:
      "The production department and the logistics team ______ collaborated to improve delivery efficiency.",
    choices: {
      A: "has",
      B: "have",
    },
    correctAnswer: "B",
    explanation:
      "'and'로 연결된 두 개의 부서는 복수 취급하므로 복수 동사 have를 사용합니다.",
    translation: "생산부서와 물류팀이 배송 효율성을 개선하기 위해 협력했다.",
    type: "subject-verb agreement",
  },
  {
    id: 42,
    koreanQuestion: "직원들이나 관리자가 승인한다 예산을 각 부서를 위한",
    question:
      "Either the employees or the manager ______ the final budget for each department.",
    choices: {
      A: "approve",
      B: "approves",
    },
    correctAnswer: "B",
    explanation:
      "'Either...or'에서 두 주어 중 가까운 주어가 단수일 경우 단수 동사를 사용합니다. 여기서는 'manager'가 단수이므로 approves를 사용합니다.",
    translation: "직원들이나 관리자 중 한 명이 각 부서의 최종 예산을 승인한다.",
    type: "subject-verb agreement",
  },
  {
    id: 43,
    koreanQuestion: "인턴들도 감독자도 참석하지 않는다 주간 성과 검토에",
    question:
      "Neither the interns nor the supervisor ______ the weekly performance review.",
    choices: {
      A: "attend",
      B: "attends",
    },
    correctAnswer: "B",
    explanation:
      "'Neither...nor'에서 두 주어 중 가까운 주어가 단수일 경우 단수 동사를 사용합니다. 여기서는 'supervisor'가 단수이므로 attends를 사용합니다.",
    translation: "인턴들도 감독자도 주간 성과 검토에 참석하지 않는다.",
    type: "subject-verb agreement",
  },
  {
    id: 44,
    koreanQuestion: "기술자들뿐만 아니라 프로젝트 리더도 감독한다 구현 과정을",
    question:
      "Not only the technicians but also the project leader ______ the implementation process.",
    choices: {
      A: "oversees",
      B: "oversee",
    },
    correctAnswer: "A",
    explanation:
      "'Not only...but also'에서 두 주어 중 'but also' 다음의 주어가 단수일 경우 단수 동사를 사용합니다. 여기서는 'project leader'가 단수이므로 oversees를 사용합니다.",
    translation: "기술자들뿐만 아니라 프로젝트 리더도 구현 과정을 감독한다.",
    type: "subject-verb agreement",
  },
  {
    id: 45,
    koreanQuestion: "마케팅 전략들이나 최종 결정이 결정한다 방향을 캠페인의",
    question:
      "Either the marketing strategies or the final decision ______ the direction of the campaign.",
    choices: {
      A: "determines",
      B: "determine",
    },
    correctAnswer: "A",
    explanation:
      "'Either...or'에서 두 주어 중 가까운 주어가 단수일 경우 단수 동사를 사용합니다. 여기서는 'final decision'이 단수이므로 determines를 사용합니다.",
    translation:
      "마케팅 전략이나 최종 결정 중 하나가 캠페인의 방향을 결정한다.",
    type: "subject-verb agreement",
  },
  {
    id: 46,
    koreanQuestion: "보조원들도 책임자도 처리하지 않는다 고객 불만을 직접",
    question:
      "Neither the assistants nor the director ______ customer complaints directly.",
    choices: {
      A: "handles",
      B: "handle",
    },
    correctAnswer: "A",
    explanation:
      "'Neither...nor'에서 두 주어 중 가까운 주어가 단수일 경우 단수 동사를 사용합니다. 여기서는 'director'가 단수이므로 handles를 사용합니다.",
    translation: "보조원들도 책임자도 고객 불만을 직접 처리하지 않는다.",
    type: "subject-verb agreement",
  },
  {
    id: 47,
    koreanQuestion: "팀장이나 직원들이 처리한다 고객 문의를 성수기 동안 ",
    question:
      "Either the team leader or the employees ______ customer inquiries during peak hours.",
    choices: {
      A: "handles",
      B: "handle",
    },
    correctAnswer: "B",
    explanation:
      "'Either...or'에서 두 주어 중 가까운 주어가 복수일 경우 복수 동사를 사용합니다. 여기서는 'employees'가 복수이므로 handle을 사용합니다.",
    translation: "팀장이나 직원들이 성수기 동안 고객 문의를 처리한다.",
    type: "subject-verb agreement",
  },
  {
    id: 48,
    koreanQuestion: "관리자도 인턴들도 근무하지 않는다 주말에",
    question: "Neither the manager nor the interns ______ on weekends.",
    choices: {
      A: "works",
      B: "work",
    },
    correctAnswer: "B",
    explanation:
      "'Neither...nor'에서 두 주어 중 가까운 주어가 복수일 경우 복수 동사를 사용합니다. 여기서는 'interns'가 복수이므로 work를 사용합니다.",
    translation: "관리자도 인턴들도 주말에 근무하지 않는다.",
    type: "subject-verb agreement",
  },
  {
    id: 49,
    koreanQuestion:
      "CEO뿐만 아니라 이사회 구성원들도 참석한다 연례 주주 총회에",
    question:
      "Not only the CEO but also the board members ______ the annual shareholder meeting.",
    choices: {
      A: "attends",
      B: "attend",
    },
    correctAnswer: "B",
    explanation:
      "'Not only...but also'에서 두 주어 중 'but also' 다음의 주어가 복수일 경우 복수 동사를 사용합니다. 여기서는 'board members'가 복수이므로 attend를 사용합니다.",
    translation: "CEO뿐만 아니라 이사회 구성원들도 연례 주주 총회에 참석한다.",
    type: "subject-verb agreement",
  },
  {
    id: 50,
    koreanQuestion: "감독자나 기술자들이 수리한다 장비를 문제가 발생했을 때 ",
    question:
      "Either the supervisor or the technicians ______ the equipment when issues arise.",
    choices: {
      A: "repairs",
      B: "repair",
    },
    correctAnswer: "B",
    explanation:
      "'Either...or'에서 두 주어 중 가까운 주어가 복수일 경우 복수 동사를 사용합니다. 여기서는 'technicians'가 복수이므로 repair를 사용합니다.",
    translation: "감독자나 기술자들이 문제가 발생했을 때 장비를 수리한다.",
    type: "subject-verb agreement",
  },
  {
    id: 51,
    koreanQuestion:
      "교수도 학생들도 참여하지 않는다 연구 프로젝트에 여름 동안 ",
    question:
      "Neither the professor nor the students ______ in the research project over the summer.",
    choices: {
      A: "participates",
      B: "participate",
    },
    correctAnswer: "B",
    explanation:
      "'Neither...nor'에서 두 주어 중 가까운 주어가 복수일 경우 복수 동사를 사용합니다. 여기서는 'students'가 복수이므로 participate를 사용합니다.",
    translation: "교수도 학생들도 여름 동안 연구 프로젝트에 참여하지 않는다.",
    type: "subject-verb agreement",
  },
  {
    id: 52,
    koreanQuestion:
      "직원들뿐만 아니라 매니저도 처리한다 고객 불만을 효율적으로",
    question:
      "The employees as well as the manager ______ customer complaints efficiently.",
    choices: {
      A: "handles",
      B: "handle",
    },
    correctAnswer: "B",
    explanation:
      "'as well as'는 'and'와 달리 첫 번째 주어에만 동사가 일치합니다. 여기서는 'employees'가 복수이므로 복수 동사 handle을 사용합니다.",
    translation: "관리자뿐만 아니라 직원들도 고객 불만을 효율적으로 처리한다.",
    type: "subject-verb agreement",
  },
  {
    id: 53,
    koreanQuestion:
      "엔지니어들뿐만 아니라 디자이너들도 개발한다  혁신적인 솔루션을 새로운 제품 라인을 위한 ",
    question:
      "The engineers as well as the designers ______ innovative solutions for the new product line.",
    choices: {
      A: "develops",
      B: "develop",
    },
    correctAnswer: "B",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'engineers'가 복수이므로 복수 동사 develop을 사용합니다.",
    translation:
      "디자이너뿐만 아니라 엔지니어들도 새로운 제품 라인을 위한 혁신적인 솔루션을 개발한다.",
    type: "subject-verb agreement",
  },
  {
    id: 54,
    koreanQuestion:
      "학생들뿐만 아니라 그들의 교수도 도 참여한다 연례 연구 컨퍼런스에 ",
    question:
      "The students as well as their professor ______ in the annual research conference.",
    choices: {
      A: "participates",
      B: "participate",
    },
    correctAnswer: "B",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'students'가 복수이므로 복수 동사 participate를 사용합니다.",
    translation: "교수뿐만 아니라 학생들도 연례 연구 컨퍼런스에 참여한다.",
    type: "subject-verb agreement",
  },
  {
    id: 55,
    koreanQuestion:
      "공급자들뿐만 아니라 물류팀도 보장한다 그.. 배송이 도착하도록 정시에",
    question:
      "The suppliers as well as the logistics team ______ that shipments arrive on time.",
    choices: {
      A: "ensures",
      B: "ensure",
    },
    correctAnswer: "B",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'suppliers'가 복수이므로 복수 동사 ensure를 사용합니다.",
    translation:
      "물류팀뿐만 아니라 공급업체들도 배송이 정시에 도착하도록 보장한다.",
    type: "subject-verb agreement",
  },
  {
    id: 56,
    koreanQuestion:
      "임원들뿐만 아니라 마케팅팀도 리뷰한다 판매 보고서를 매 분기마다 ",
    question:
      "The executives as well as the marketing team ______ the sales report every quarter.",
    choices: {
      A: "reviews",
      B: "review",
    },
    correctAnswer: "B",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'executives'가 복수이므로 복수 동사 review를 사용합니다.",
    translation:
      "마케팅팀뿐만 아니라 임원들도 매 분기마다 판매 보고서를 검토한다.",
    type: "subject-verb agreement",
  },
  {
    id: 57,
    koreanQuestion:
      "관리자 뿐만 아니라 직원들도 감독한다 시행을 새로운 회사 정책의  ",
    question:
      "The manager as well as the employees ______ the implementation of the new company policies.",
    choices: {
      A: "oversees",
      B: "oversee",
    },
    correctAnswer: "A",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'manager'가 단수이므로 단수 동사 oversees를 사용합니다.",
    translation:
      "직원들뿐만 아니라 관리자도 새로운 회사 정책의 시행을 감독한다.",
    type: "subject-verb agreement",
  },
  {
    id: 58,
    koreanQuestion:
      "보고서 뿐만 아니라 보조 문서들도 필요로 한다 승인을 법무부로부터",
    question:
      "The report as well as the supporting documents ______ approval from the legal department.",
    choices: {
      A: "requires",
      B: "require",
    },
    correctAnswer: "A",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'report'가 단수이므로 단수 동사 requires를 사용합니다.",
    translation:
      "보조 문서들뿐만 아니라 보고서도 법무부서의 승인을 필요로 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 59,
    koreanQuestion:
      "CEO뿐만 아니라 이사회 멤버들도 내린다 최종 결정을 기업 투자에 대한 ",
    question:
      "The CEO as well as the board members ______ the final decision on corporate investments.",
    choices: {
      A: "makes",
      B: "make",
    },
    correctAnswer: "A",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'CEO'가 단수이므로 단수 동사 makes를 사용합니다.",
    translation:
      "이사회 구성원들뿐만 아니라 CEO도 기업 투자에 대한 최종 결정을 내린다.",
    type: "subject-verb agreement",
  },
  {
    id: 60,
    koreanQuestion:
      "교육 프로그램뿐만 아니라 개인 코칭 세션도 돕는다 신입 직원들이 적응하도록 빨리",
    question:
      "The training program as well as the individual coaching session ______ new employees adapt quickly.",
    choices: {
      A: "helps",
      B: "help",
    },
    correctAnswer: "A",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'training program'이 단수이므로 단수 동사 helps를 사용합니다.",
    translation:
      "개별 코칭 세션뿐만 아니라 교육 프로그램도 신입 직원들이 빨리 적응하도록 돕는다.",
    type: "subject-verb agreement",
  },
  {
    id: 61,
    koreanQuestion:
      "주 연사뿐만 아니라 패널리스트들도 기조연설한다 컨퍼런스에서",
    question:
      "The main speaker as well as the panelists ______ a keynote speech at the conference.",
    choices: {
      A: "delivers",
      B: "deliver",
    },
    correctAnswer: "A",
    explanation:
      "'as well as'는 첫 번째 주어에만 동사가 일치합니다. 여기서는 'main speaker'가 단수이므로 단수 동사 delivers를 사용합니다.",
    translation:
      "패널리스트들뿐만 아니라 주 연사도 컨퍼런스에서 기조연설을 한다.",
    type: "subject-verb agreement",
  },

  {
    id: 62,
    koreanQuestion: "서류들 그..필요한 비자신청과정에 포함한다  상세한 지침을 ",
    question:
      "The documents required for the visa application process ______ detailed instructions.",
    choices: {
      A: "contains",
      B: "contain",
    },
    correctAnswer: "B",
    explanation:
      "'documents'가 복수 주어이므로 복수 동사 contain을 사용합니다. 수식어구가 길더라도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation: "비자 신청 과정에 필요한 서류들이 상세한 지침을 포함한다.",
    type: "subject-verb agreement",
  },
  {
    id: 63,
    koreanQuestion:
      "직원들은 그..담당하는 처리를 고객불만 응답한다 문의들에 24간안에",
    question:
      "The employees responsible for handling customer complaints ______ to inquiries within 24 hours.",
    choices: {
      A: "responds",
      B: "respond",
    },
    correctAnswer: "B",
    explanation:
      "'employees'가 복수 주어이므로 복수 동사 respond를 사용합니다. 수식어구가 길더라도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation:
      "고객 불만 처리를 담당하는 직원들이 24시간 이내에 문의에 응답한다.",
    type: "subject-verb agreement",
  },
  {
    id: 64,
    koreanQuestion: "안전 규정들이  명시된 직원 핸드북에 적용된다 모든 부서에 ",
    question:
      "The safety regulations outlined in the employee handbook ______ to all departments.",
    choices: {
      A: "applies",
      B: "apply",
    },
    correctAnswer: "B",
    explanation:
      "'regulations'가 복수 주어이므로 복수 동사 apply를 사용합니다. 수식어구가 길더라도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation: "직원 핸드북에 명시된 안전 규정들이 모든 부서에 적용된다.",
    type: "subject-verb agreement",
  },
  {
    id: 65,
    koreanQuestion: "결과들이 최근 시장 분석 보여준다 변화를 소비자 선호도의",
    question:
      "The results of the recent market analysis ______ a shift in consumer preferences.",
    choices: {
      A: "indicates",
      B: "indicate",
    },
    correctAnswer: "B",
    explanation:
      "'results'가 복수 주어이므로 복수 동사 indicate를 사용합니다. 전치사구가 뒤따라와도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation: "최근 시장 분석의 결과들이 소비자 선호도의 변화를 보여준다.",
    type: "subject-verb agreement",
  },
  {
    id: 66,
    koreanQuestion:
      "보수공사들이 그...계획된 두 사무실 건물들에 영향을 미친다 업무 일정에 다음 달 ",
    question:
      "The renovations planned for both office buildings ______ the work schedule next month.",
    choices: {
      A: "affects",
      B: "affect",
    },
    correctAnswer: "B",
    explanation:
      "'renovations'가 복수 주어이므로 복수 동사 affect를 사용합니다. 수식어구가 길더라도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation:
      "두 사무실 건물에 대해 계획된 보수공사가 다음 달 업무 일정에 영향을 미친다.",
    type: "subject-verb agreement",
  },
  {
    id: 67,
    koreanQuestion:
      "보고서가 최근 재무 성과 제공한다 가치있는 통찰을 투자자들에게",
    question:
      "The report on the recent financial performance ______ valuable insights for investors.",
    choices: {
      A: "provide",
      B: "provides",
    },
    correctAnswer: "B",
    explanation:
      "'report'가 단수 주어이므로 단수 동사 provides를 사용합니다. 전치사구가 뒤따라와도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation:
      "최근 재무 성과에 대한 보고서가 투자자들에게 가치 있는 통찰을 제공한다.",
    type: "subject-verb agreement",
  },
  {
    id: 68,
    koreanQuestion:
      "일정이 다가오는 교육세션의 포함한다 여러 상호작용 워크샵을",
    question:
      "The schedule for the upcoming training session ______ several interactive workshops.",
    choices: {
      A: "includes",
      B: "include",
    },
    correctAnswer: "A",
    explanation:
      "'schedule'이 단수 주어이므로 단수 동사 includes를 사용합니다. 전치사구가 뒤따라와도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation: "예정된 교육 세션의 일정이 여러 상호작용 워크샵을 포함한다.",
    type: "subject-verb agreement",
  },
  {
    id: 69,
    koreanQuestion:
      "장비가 그.. 사용되는 생산에 메디컬 장비들을 필요로 한다 정기적인 유지보수를",
    question:
      "The equipment used in the production of medical devices ______ regular maintenance.",
    choices: {
      A: "requires",
      B: "require",
    },
    correctAnswer: "A",
    explanation:
      "'equipment'가 단수 주어이므로 단수 동사 requires를 사용합니다. 수식어구가 길더라도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation:
      "의료기기 생산에 사용되는 장비가 정기적인 유지보수를 필요로 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 70,
    koreanQuestion:
      "제안서가 그.. 제출된 마케팅 팀에 의해 설명한다 새로운 광고 전략을",
    question:
      "The proposal submitted by the marketing team ______ a new advertising strategy.",
    choices: {
      A: "outlines",
      B: "outline",
    },
    correctAnswer: "A",
    explanation:
      "'proposal'이 단수 주어이므로 단수 동사 outlines를 사용합니다. 수식어구가 뒤따라와도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation: "마케팅팀이 제출한 제안서가 새로운 광고 전략을 설명한다.",
    type: "subject-verb agreement",
  },
  {
    id: 71,
    koreanQuestion:
      "정책이 재택근무에 관한 할 수 있게 한다 직원들이 재택근무를 2회 / 주",
    question:
      "The policy regarding remote work ______ employees to work from home twice a week.",
    choices: {
      A: "allows",
      B: "allow",
    },
    correctAnswer: "A",
    explanation:
      "'policy'가 단수 주어이므로 단수 동사 allows를 사용합니다. 전치사구가 뒤따라와도 주어의 수에 따라 동사를 선택해야 합니다.",
    translation:
      "원격 근무에 관한 정책이 직원들이 주 2회 재택근무를 할 수 있게 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 72,
    koreanQuestion:
      " _____ 는 지원자들 중 요구된다 제출하도록 포트폴리오를 인터뷰 전에  ",
    question:
      "______ of the applicants is required to submit a portfolio before the interview.",
    choices: {
      A: "Each",
      B: "All",
    },
    correctAnswer: "A",
    explanation:
      "'Each of + 복수명사'는 단수 취급하므로 단수 동사 is를 사용합니다.",
    translation: "지원자들 중 각각은 면접 전에 포트폴리오를 제출해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 73,
    koreanQuestion: "_______ 은  직원들중 책임이 있다 따를 회사의 안전 규정을 ",
    question:
      "______ of the employees are responsible for following the company's safety regulations.",
    choices: {
      A: "Each",
      B: "All",
    },
    correctAnswer: "B",
    explanation:
      "'All of + 복수명사'는 복수 취급하므로 복수 동사 are를 사용합니다.",
    translation: "모든 직원들은 회사의 안전 규정을 준수할 책임이 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 74,
    koreanQuestion:
      "_______ 은 지원자 요구된다 참석하도록 오리엔테이션 세션에 ",
    question: "______ applicant is required to attend the orientation session.",
    choices: {
      A: "Each",
      B: "Every",
    },
    correctAnswer: "B",
    explanation:
      "'Every + 단수명사'는 단수 취급하므로 단수 동사 is를 사용합니다.",
    translation: "모든 지원자는 오리엔테이션 세션에 참석해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 75,
    koreanQuestion: "_______ 은 직원들 참석 중이다  연례 컨퍼런스에 뉴욕에서",
    question:
      "______ employees are attending the annual conference in New York.",
    choices: {
      A: "A number of",
      B: "The number of",
    },
    correctAnswer: "A",
    explanation:
      "'A number of + 복수명사'는 복수 취급하므로 복수 동사 are를 사용합니다.",
    translation:
      "다수의 직원들이 뉴욕에서 열리는 연례 컨퍼런스에 참석하고 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 76,
    koreanQuestion: " _______ 은 직원들 증가하는 중이다  회사 확장으로 인해",
    question: "______ employees is increasing due to the company's expansion.",
    choices: {
      A: "A number of",
      B: "The number of",
    },
    correctAnswer: "B",
    explanation:
      "'The number of + 복수명사'는 단수 취급하므로 단수 동사 is를 사용합니다.",
    translation: "회사 확장으로 인해 직원 수가 증가하고 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 77,
    koreanQuestion:
      "모든 사람들은 사무실에 있는 요구된다 참석하도록 주간 회의에 ",
    question:
      "Everyone in the office ______ required to attend the weekly meeting.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Everyone'은 단수 취급하므로 단수 동사 is를 사용합니다. 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation: "사무실의 모든 사람이 주간 회의에 참석해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 78,
    koreanQuestion:
      "각각은 후보자들 주어졌다 동등한 기회가 보여줄 그들의 기술을  ",
    question:
      "Each of the candidates ______ given an equal opportunity to showcase their skills.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "A",
    explanation:
      "'Each of + 복수명사'는 단수 취급하므로 단수 동사 was를 사용합니다.",
    translation:
      "후보자들 각각에게 자신의 기술을 보여줄 동등한 기회가 주어졌다.",
    type: "subject-verb agreement",
  },
  {
    id: 79,
    koreanQuestion: "아무도 회사 내에서 알지 못했다 갑작스러운 정책 변경을",
    question:
      "Nobody in the department ______ aware of the sudden policy change.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Nobody'는 단수 취급하므로 단수 동사 is를 사용합니다. 전치사구가 뒤따라와도 단수 동사를 사용합니다.",
    translation: "부서의 누구도 갑작스러운 정책 변경을 알지 못했다.",
    type: "subject-verb agreement",
  },
  {
    id: 80,
    koreanQuestion: "모든 직원은 기대된다 완료하도록 교육을 다움주 금요일까지 ",
    question:
      "Every employee ______ expected to complete the training by next Friday.",
    choices: {
      A: "is",
      B: "are",
    },
    correctAnswer: "A",
    explanation:
      "'Every + 단수명사'는 단수 취급하므로 단수 동사 is를 사용합니다.",
    translation:
      "모든 직원이 다음 주 금요일까지 교육을 완료할 것으로 예상된다.",
    type: "subject-verb agreement",
  },
  {
    id: 81,
    koreanQuestion:
      "누구나 그.. 관심있는 지원하는데 이 자리에 제출해야 한다 자기소개서를 이력서와 함께  ",
    question:
      "Anyone interested in applying for the position ______ submit a cover letter along with their resume.",
    choices: {
      A: "needs to",
      B: "need to",
    },
    correctAnswer: "A",
    explanation:
      "'Anyone'은 단수 취급하므로 단수 동사 needs to를 사용합니다. 수식어구가 뒤따라와도 단수 동사를 사용합니다.",
    translation:
      "이 직책에 지원하는데 관심이 있는 사람은 누구나 이력서와 함께 자기소개서를 제출해야 한다.",
    type: "subject-verb agreement",
  },

  {
    id: 82,
    koreanQuestion: "_____ 은 제안서들 (현재) 검토됬다 디렉터에 의해",
    question: "______ of the proposals has been reviewed by the director.",
    choices: {
      A: "Each",
      B: "All",
    },
    correctAnswer: "A",
    explanation:
      "'Each of + 복수명사'는 단수 취급하므로 단수 동사 has를 사용합니다. 'All of the proposals'라면 'have been'을 사용해야 합니다.",
    translation: "제안서 각각이 이사에 의해 검토되었다.",
    type: "subject-verb agreement",
  },
  {
    id: 83,
    koreanQuestion: " ____ 은 직원들 요구된다 완료하도록 교육을 금요일까지 ",
    question:
      "______ of the employees are required to complete the training by Friday.",
    choices: {
      A: "Each",
      B: "All",
    },
    correctAnswer: "B",
    explanation:
      "'All of + 복수명사'는 복수 취급하므로 복수 동사 are를 사용합니다. 'Each of'라면 'is required'를 사용해야 합니다.",
    translation: "모든 직원들은 금요일까지 교육을 완료해야 한다.",
    type: "subject-verb agreement",
  },
  {
    id: 84,
    koreanQuestion: "______ 은 직원 책임이 있다 제출할 월간 보고서를 ",
    question: "______ employee is responsible for submitting a monthly report.",
    choices: {
      A: "Every",
      B: "All",
    },
    correctAnswer: "A",
    explanation:
      "'Every + 단수명사'는 단수 취급하므로 단수 동사 is를 사용합니다. 'Each employee'도 가능하지만, 'Every'가 더 일반적으로 사용됩니다.",
    translation: "모든 직원은 월간 보고서를 제출할 책임이 있다.",
    type: "subject-verb agreement",
  },
  {
    id: 85,
    koreanQuestion: " 많은 수의 불만들이 받아졌다 지연된 배송에 대해 ",
    question:
      "A large number of complaints _____ received about the delayed delivery.",
    choices: {
      A: "was",
      B: "were",
    },
    correctAnswer: "B",
    explanation:
      "'A large number of complaints'는 복수 취급하므로 복수 동사 'were'를 사용합니다. 주어가 'complaints'이기 때문에 복수형 동사가 필요합니다.",
    translation: "많은 수의 불만사항이 지연된 배송에 대해 접수되었다.",
    type: "subject-verb agreement",
  },
];
